//const Backofficebff: string = "/backofficebff/service/api/v1";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const DesignCollectiveCommand: any = {
    PostDesignCollectiveFilterData: `${Backofficebff}/v1/designcollective/print`,
    PutDesignCollectiveStatusUpdate: `${Backofficebff}/v1/designcollective/update`,
    PostTransferData: `${Backofficebff}/v1/cargo/setuplabelprinting`,
};
